<template>
  <el-container class="body_container">
    <el-header style="height: 100px;padding:0px">
      <el-row class="body_title">学时  (通过输入“姓名/执业证号/律所”查询)</el-row>
      <el-form v-model="searchVo" :inline="true" ref="search">
        <el-row type="flex">
          <el-col>
            <el-form-item  label-width="40px"  size="small">
              <el-input v-model="searchVo.keyword" placeholder="姓名/执业证号/律所"  style="width: 160px">
                <el-button  @click="search" icon="el-icon-search"></el-button>
              </el-input>
            </el-form-item>
            <el-form-item  label-width="40px"  size="small" >
              <el-select v-model="year" placeholder="学年" @change="changeYear" style="width: 100px">
                <el-option label="去年" value="last"></el-option>
                <el-option label="前年" value="before"></el-option>
              </el-select>
              <el-date-picker
                v-model="dateValue"
                type="daterange"
                value-format="yyyy-MM-dd"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期">
              </el-date-picker>
              <!--<el-date-picker-->
                <!--style="width: 150px"-->
                <!--v-model="searchVo.startTime"-->
                <!--type="date"-->
                <!--value-format="yyyy-MM-dd"-->
                <!--placeholder="选择开始日期">-->
              <!--</el-date-picker>-->
              <!--<el-date-picker-->
                <!--style="width: 150px"-->
                <!--v-model="searchVo.endTime"-->
                <!--value-format="yyyy-MM-dd"-->
                <!--type="date"-->
                <!--placeholder="选择结束时间">-->
              <!--</el-date-picker>-->
            </el-form-item>
            <el-form-item class="dialog-footer" >
              <el-button type="primary" @click="search">查询</el-button>
              <el-button @click="resetForm('search')" style="background-color: #fff;border: 1px solid #3e64ff;color: #3e64ff;padding: 7px 12px">重置</el-button>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </el-header>
    <el-main class="search_result">
      <el-table :data="periods.list" v-loading="loading">
        <el-table-column prop="lawyerName" label="律师名称" width="90px"></el-table-column>
        <el-table-column prop="createdBy" label="执业证号" min-width="175px"></el-table-column>
        <el-table-column prop="assName" :show-overflow-tooltip="true" label="律协名称" min-width="100px"></el-table-column>
        <el-table-column prop="office" :show-overflow-tooltip="true" label="律所名称" min-width="100px"></el-table-column>
        <el-table-column prop="videoName" :show-overflow-tooltip="true" label="直播标题" min-width="70px"></el-table-column>
        <!--<el-table-column prop="totalScore" label="总分" width="130px"></el-table-column>-->
        <el-table-column prop="videoType" label="视频类型" :formatter="formatterVideoType" min-width="70px"></el-table-column>
        <el-table-column prop="startTime" label="开始时间" min-width="180px"></el-table-column>
        <el-table-column prop="endTime" label="结束时间" min-width="180px"></el-table-column>
        <el-table-column prop="watchingTime" label="视频时间(分)" width="80px">
          <template slot-scope="scope">
           {{periodMin(scope.row.watchingTime)}}
          </template>
        </el-table-column>
        <el-table-column prop="clientType" label="终端类型" :formatter="formatterClientType"></el-table-column>
        <!--<el-table-column prop="lawyerId" label="操作">-->
        <!--<template slot-scope="scope">-->
        <!--<el-button-->
        <!--size="mini"-->
        <!--@click="checkPeriod(scope.row)"><i class="qb-icon-caozuo1" style="font-size: 20px"></i></el-button>-->
        <!--</template>-->
        <!--</el-table-column>-->
      </el-table>
    </el-main>
    <el-pagination class="page"
                   @size-change="handleSizeChange"
                   @current-change="handleCurrentChange"
                   :page-size="periods.rows"
                   :current-page="periods.page"
                   layout="prev, pager, next, jumper"
                   :total="periods.total">
    </el-pagination>
  </el-container>
</template>

<script>
import period from '@/api/period'
import store from '../../store/index'
export default {
  name: 'Period',
  data () {
    return {
      value: true,
      dateValue: '',
      globalAssId: null,
      lawyerId: null,
      loading: false,
      addLawyerVisible: false,
      periods: {
        page: 1,
        rows: 10,
        total: 0,
        list: []
      },
      year: null,
      month: null,
      day: null,
      searchVo: {
        keyword: '',
        startTime: '',
        endTime: ''
      },
      page: 1,
      size: 15
    }
  },
  methods: {
    handleSizeChange (val) {
      // console.log(`每页 ${val} 条`)
    },
    handleCurrentChange (val) {
      // console.log(`当前页: ${val}`)
      this.page = val
      this.reload()
    },
    reload () {
      this.loading = true
      this.searchVo.startTime = this.dateValue[0]
      this.searchVo.endTime = this.dateValue[1]
      period.view({page: this.page, rows: this.size, startTime: this.searchVo.startTime, endTime: this.searchVo.endTime, keyword: this.searchVo.keyword, assId: this.globalAssId}).then(res => {
        this.periods = res.data.data
        this.loading = false
      })
    },
    search () {
      this.page = 1
      this.reload()
    },
    // 重置form
    resetForm () {
      this.searchVo.keyword = ''
      this.searchVo.startTime = ''
      this.searchVo.endTime = ''
      this.dateValue = ''
      this.year = null
      this.periods ={
        page: 1,
        rows: 10,
        total: 0,
        list: []
      }
      // this.reload()
    },
    formatterVideoType (row, column) {
      return row.videoType === 'L' ? '直播' : row.videoType === 'H' ? '历史直播' : row.videoType === 'C' ? '课件' : '未知'
    },
    formatterClientType (row, column) {
      return row.clientType === 'A' ? '安卓' : row.clientType === 'B' ? '浏览器' : row.clientType === 'O' ? '苹果' : '未知'
    },
    updateData (val) {
      this.page = val
      this.reload()
    },
    periodMin (value) {
      return Math.floor(value/60)
    },
    dateBiJiao (firstDate, lastDate) {
      var arr = firstDate.split("-");
      var firsttime = new Date(arr[0], arr[1], arr[2]);
      var firsttimes = firsttime.getTime();

      var arrs = lastDate.split("-");
      var  lasttime = new Date(arrs[0], arrs[1], arrs[2]);
       var  lasttimes =  lasttime.getTime();

      if (firsttimes>= lasttimes) {
            return true;
         }
       else
         return false;
   },
    changeYear (values) {
      var date = new Date();
      const year = date.getFullYear();
      const month = date.getMonth()+1;
      const day = date.getDate();
      // 上一年周期
      if (values === 'last') {
        // 如果该日期比当前日期晚 this > month，则以该日期为终点，上一年该日期为起点，为一个年度。
        // 2019,06.01 -2020.06.01
        if (this.dateBiJiao((year + '-' + this.month + '-' + this.day),(year + '-' + month + '-' + day))) {
          this.searchVo.startTime =  year-2 + '-' + this.month + '-' + this.day //'2018.06.01'
          this.searchVo.endTime =  year-1 + '-' + this.month + '-' + this.day //'2019.06.01'
          this.dateValue = [this.searchVo.startTime,this.searchVo.endTime]
        // 如果该日期比当前日期早，则以该日期为起点，下一年该日期为终点，为一个年度。
        // 2020,05.01 -2021.05.01
        } else{
          this.searchVo.startTime =  year-1 + '-' + this.month + '-' + this.day //'2019.05.01'
          this.searchVo.endTime = year + '-' + this.month + '-' + this.day //'2020.05.01'
          this.dateValue = [this.searchVo.startTime,this.searchVo.endTime]
        }
      }
      // 上上周期
      if (values === 'before') {
        // 如果该日期比当前日期晚 this > month，则以该日期为终点，上一年该日期为起点，为一个年度。
        // 2019,06.01 -2020.06.01
        if (this.dateBiJiao((year + '-' + this.month + '-' + this.day),(year + '-' + month + '-' + day))) {
          this.searchVo.startTime =  year-3 + '-' + this.month + '-' + this.day //'2017.06.01'
          this.searchVo.endTime =  year-2 + '-' + this.month + '-' + this.day //'2018.06.01'
          this.dateValue = [this.searchVo.startTime,this.searchVo.endTime]
        // 如果该日期比当前日期早，则以该日期为起点，下一年该日期为终点，为一个年度。
        // 2020,05.01 -2021.05.01
        } else {
          this.searchVo.startTime =  year-2 + '-' + this.month + '-' + this.day //'2018.05.01'
          this.searchVo.endTime = year-1 + '-' + this.month + '-' + this.day //'2019.05.01'
          this.dateValue = [this.searchVo.startTime,this.searchVo.endTime]
        }
      }
    }
  },
  created () {
    period.findTimeNode().then(res => {
      this.month = parseInt(res.data.data[0].month)
      this.day = parseInt(res.data.data[0].day)
    })
    if (store.getters.getAsId === '') {
      this.globalAssId = null
    }else {
      this.globalAssId = store.getters.getAsId
    }
    // console.log(this.globalAssId)
    // this.reload()
  }
}
</script>



// WEBPACK FOOTER //
// src/components/lawyer/Period.vue